export default "__VITE_ASSET__BYEM$eaX__"